/* On Pardot Form Submissions we will validate fields
and supply the Pardot handler if fields are valid. */

function onSubmit(token) {

  jQuery(function ($) {

    // Set valid until otherwise indicated
    var validatedComplete = "validated";

    // Set Form Element
    var form = $("#pardot-contact-form #contact-form-submit").parents('form');

    // Reset feedback
    $(form).find('.invalid-feedback').remove();

    // Loop through fields
    $(form).find('input,textarea,select').filter('[required]').each(function () {
      var inputID = $(this).attr('id');
      var inputVal = $(this).val();
      var inputType = $(this).attr('type');
      var formGroup = $(this).parent('.form-group');
      var elementType = $(this).prop('nodeName');

      // Check for input value
      if (!inputVal) {

        // If no input value, invalidate
        $('<div class="invalid-feedback">This field is required.</div>').appendTo(formGroup).show();
        validatedComplete = false;

      } else if (inputVal == "") {

        // If blank input value, invalidate
        $('<div class="invalid-feedback">This field is required.</div>').appendTo(formGroup).show();
        validatedComplete = false;

      } else if (inputVal == 'undefined') {

        // If undefined input value, invalidate
        $('<div class="invalid-feedback">This field is required.</div>').appendTo(formGroup).show();
        validatedComplete = false;

      } else if (inputVal == 'State* (Available for full and part-time Maine residents only.)') {

        // If dropdown placeholder value, invalidate
        $('<div class="invalid-feedback">This field is required.</div>').appendTo(formGroup).show();
        validatedComplete = false;

      } else {

        var formGroup = $(this).parent('.form-group');

        if (inputType == 'email') {

          // If not an email address, invalidate
          if (!validateEmail(inputVal)) {

            $('<div class="invalid-feedback">A valid email address is required.</div>').appendTo(formGroup).show();
            validatedComplete = false;

          }

        }

      }

    });

    // Reject URLs from textareas
    $(form).find('textarea').each(function () {
      var inputVal = $(this).val();
      var formGroup = $(this).parent('.form-group');

      // If url is found in textarea, invalidate
      if (validateTextarea(inputVal)) {
        $('<div class="invalid-feedback">URLs are not allowed in comments.</div>').appendTo(formGroup).show();
        validatedComplete = false;
      }
    });

    // Check radio option is selected
    if ($('div').hasClass('form-horiz-radio')) {
      $('div.form-horiz-radio').each(function () {
        var formRadioGroup = $(this);

        // If no radio selected, invalidate
        if (!$(formRadioGroup).find("input[name='inlineRadioOptions']:checked").val()) {
          $('<div class="invalid-feedback">Please select a radio option.</div>').appendTo(formRadioGroup).show();
          validatedComplete = false;
        }
      });
    }

    // On Specific Forms, reject email addresses from blacklist
    if (form.hasClass('brand-awareness-form') || form.hasClass('bridge-loans-form') || form.hasClass('lender-finance-form') || form.hasClass('national-lending-form')) {
      var email = $("input[type='email']").val();

      // Check against blacklist
      var emailReg = /^([\w-\.]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!icloud.com)(?!aol.com)(?!abc.com)(?!xyz.com)(?!pqr.com)(?!rediffmail.com)(?!live.com)(?!outlook.com)(?!me.com)(?!msn.com)(?!ymail.com)([\w-]+\.)+[\w-]{2,4})?$/;

      // If email contains blacklist, invalidate
      if (!emailReg.test(email)) {
        var formGroup = $("input[type='email']").parent('.form-group');
        $('<div class="invalid-feedback">Please use your business email address.</div>').appendTo(formGroup).show();
        validatedComplete = false;
      }
    }


    // Check hidden form field for value
    var form_validator = $("#form_validator").val();
    // If value exists, invalidate
    if (form_validator != '') {
      validatedComplete = false;
    }


    // If form remains valid, get Pardot handler and supply to form action and submit form.
    if (validatedComplete == "validated") {
      var handler = $('#pardot-contact-form').data('handler');
      $('#pardot-contact-form').attr('action', 'https://go.northeastbank.com' + handler).submit();
    }

  });
}

// Validate email format
function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test($email);
}

// Check for URL formats in textarea
function validateTextarea($url) {
  var urlReg = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,5})?(\/.*)?/g;
  return urlReg.test($url);
}


/*
  Document Ready
*/
(function(window, document, $) {
	$(document).ready(function() {


    // Remove error messages when user modifies form field
    $('#pardot-contact-form input,#pardot-contact-form textarea,#pardot-contact-form select').on('input', function () {
      if ($(this).val().length > 0) {
        $(this).siblings('.invalid-feedback').remove();
      }
    });


    


    /* TB Mega Menu - Adjustments to modify the width
    and position of the dropdown container */
    function dropdownWidth() {
      var windowWidth = $(window).width();
      if (windowWidth > 992) {
        if ($('.new-primary-menu').hasClass('menu-open')) {
          $('.new-primary-menu').removeClass('menu-open');
        }
      }
      $(".tbm .tbm-item.level-1").each(function () {
        $(this).find('.tbm-submenu').css({
          width: "100%",
          left: 0
        });
      });
    }
    dropdownWidth();
    $(window).resize(function () {
      dropdownWidth();
    });

    // Mobile navigation display toggle
		$('.mobile-nav-trigger').on("click", function(e) {
			e.preventDefault();
      $('#mobile-nav-container').slideToggle();
      $('.new-primary-menu').toggleClass('menu-open');
		});

    /* Login Overlay - On interior pages the "login" button
    in the navigation opens an overlay. This triggers that display */
    const blockIds = ['#block-neb-site-main-menu', '#block-mobilemenu'];

    blockIds.forEach((id) => {
      $(`${id} a[href="#online-login"]`).on("click", function(e) {
        e.preventDefault();
        $('#online-login').fadeIn();
      });
    });

		// Login Overlay - hide the overlay
		$('#online-login .overlay-close').on("click", function(e) {
			e.preventDefault();
			$('#online-login').fadeOut();
		});

    /* Email links - This checks all email links for specific domains
    and if it is considered external an email specific exit modal will display. */
		$('a[href^="mailto:"]').removeClass('exit-modal-trigger').removeClass('local').addClass('email-modal-trigger').attr('data-toggle', 'modal').attr('data-target', "#footerEmailModal");

    // Supply appropriate email address in email specific modal when user "confirms"
		$('.email-modal-trigger').on("click", function(e) {
			e.preventDefault();
			var targetHREF = $(this).attr('href');
			$('#footerEmailModal').find('a.btn-success').attr('href', targetHREF);
		});


		// Add "_blank" target to all external links except those specified here.
		$('a').each(function() {
			var a = new RegExp('/' + window.location.host + '/');
			if (!a.test(this.href) && this.hostname!='investor.northeastbank.com') {
				$(this).attr("target", "_blank");
			}
		});

		// Add "_blank" target to all links with .pdf
		$('a[href*=".pdf"]').each(function() {
				$(this).attr("target", "_blank");
		});

		// Add empty "alt" tag if not present
		$("img:not([alt])").attr("alt", "");


		// Create a "clickable" class which makes entire container clickable
		$('.clickable').click(function(e) {
			$(this).find("a").click();
		});

		$('.clickable a').on("click", function(e) {
			e.stopPropagation();
			var targetHREF = $(this).attr('href');
			if ($(this).hasClass('exit-modal-trigger')) {
				$('#exitModal').find('a.btn-success').attr('href', targetHREF);
				$('#exitModal').modal('show');
			} else {
				window.location.href = targetHREF;
			}
    });

    // Slick Slider - Featured Deals
    // paragraph--featured-deal.html.twig
		var slideItem = $('.featured-deal-item').parent();
		$(".featured-deals-row > div > div").slick({
			infinite: true,
			arrow: true,
			dots: false,
			nextArrow: '<i class="far fa-angle-right"></i>',
			prevArrow: '<i class="far fa-angle-left"></i>',
		}).slick('slickFilter', slideItem);

    // Fixing phone number to remove dashes
    $("#inputTelephone").keydown(function() {
      $(this).val($(this).val().replaceAll('-', ''));
      $(this).val($(this).val().replaceAll(' ', ''));
      $(this).val($(this).val().replaceAll(/[^\d]/g, ''));
    });

    $("#inputTelephone").blur(function() {
      $(this).val($(this).val().replaceAll('-', ''));
      $(this).val($(this).val().replaceAll(' ', ''));
      $(this).val($(this).val().replaceAll(/[^\d]/g, ''));
    });


		/* Pull UTM variables into form */
    if ($( ".pardot-form-container, .lp-special-savings-form-container" ).length ) {

			  var queryForm = function(settings){
			    var reset = settings && settings.reset ? settings.reset : false;
			    var self = window.location.toString();
			    var querystring = self.split("?");
			    if (querystring.length > 1) {
			      var pairs = querystring[1].split("&");
			      for (i in pairs) {
			        var keyval = pairs[i].split("=");
			        if (reset || sessionStorage.getItem(keyval[0]) === null) {
			          sessionStorage.setItem(keyval[0], decodeURIComponent(keyval[1]));
			        }
			      }
			    }
			    var hiddenFields = document.querySelectorAll("input[type=hidden], input[type=text]");
			    for (var i=0; i<hiddenFields.length; i++) {
			      var param = sessionStorage.getItem(hiddenFields[i].name);
			      if (param) document.getElementsByName(hiddenFields[i].name)[0].value = param;
			    }
			  }
			  setTimeout(function(){queryForm();}, 2000);
    }


		// Smooth scroll anchors
		// Select all links with hashes
		$('a[href*="#"]')
			// Remove links that don't actually link to anything
			.not('[href="#"]')
			.not('[href="#0"]')
			.not('.nav-link')
			.not('.exit-modal-trigger')
			.not('.email-modal-trigger')
			.on("click", function(event) {
				// On-page links
				$(this).removeClass('exit-modal-trigger');
				$(this).removeClass('email-modal-trigger');
				if (
					location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
					location.hostname == this.hostname
				) {
					// Figure out element to scroll to
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
					// Does a scroll target exist?
					if (target.length) {
						// Only prevent default if animation is actually gonna happen
						event.preventDefault();
						$('html, body').animate({
							scrollTop: target.offset().top - 100
						}, 1000, function() {
							// Callback after animation
							// Must change focus!
							var $target = $(target);
							$target.focus();
							if ($target.is(":focus")) { // Checking if the target was focused
								return false;
							} else {
								$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
								$target.focus(); // Set focus again
							};
						});
					}
				}
			});


	});
})(window, document, jQuery);

(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.speedbump = {
    attach: function (context, settings) {
       /* Local and External links - This checks all links for specific domains
    and if it is considered external an exit modal will display. */
      $('a').each(function() {
        if (location.hostname === this.hostname || !this.hostname.length) {
          $(this).addClass('local');
        } else if ( drupalSettings.neb.excluded_urls.includes(this.hostname) ) {
          $(this).addClass('local');
        }else {
          $(this).addClass('exit-modal-trigger').attr('data-toggle', 'modal').attr('data-target', "#exitModal");
        }
      });

      $('a.exit-modal-trigger').on("click",function(e) {
        e.preventDefault()
        var targetHREF = $(this).attr('href');
        $('#exitModal').find('a.btn-success').attr('href', targetHREF);
        $('#exitModal').modal()

      })

      // Slick Slider - Testimonial Slider
      // paragraph--testimonial-slider.html.twig

      $('.testimonial-slider').slick({
        dots: true,
        infinite: true,
        appendDots: '.testimonial-dots',
        nextArrow: $('.next-testimonial'),
        prevArrow: $('.prev-testimonial'),
        adaptiveHeight: true
      });

      // Adjust placement of previous arror on Testimonial Slider.
      $('.testimonial-slider').on('init', function (event, slick) {
        var prevArrow = $('.slick-arrow.fa-arrow-left').detach();
        $(prevArrow).appendTo('.')

      });

    }
  }

})(jQuery, Drupal, drupalSettings);
